import { render, staticRenderFns } from "./productAdd.vue?vue&type=template&id=64053048&scoped=true&"
import script from "./productAdd.vue?vue&type=script&lang=js&"
export * from "./productAdd.vue?vue&type=script&lang=js&"
import style0 from "./productAdd.vue?vue&type=style&index=0&id=64053048&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64053048",
  null
  
)

export default component.exports